import type { ThemeConfig } from 'antd';

import { getCssVarValue } from '../utils';

export const getTheme = (isFACCM: boolean): ThemeConfig => ({
    cssVar: true,
    token: {
        screenLG: 1024,
        fontFamily: getCssVarValue('font-family'),
        fontSize: getCssVarValue('font-size', true),
        lineHeight: 1.55,
        fontWeightStrong: 600,
        fontSizeHeading1: getCssVarValue('font-size-level-1', true),
        lineHeightHeading1: 1.2,
        fontSizeHeading2: getCssVarValue('font-size-level-2', true),
        lineHeightHeading2: 1.25,
        fontSizeHeading3: getCssVarValue('font-size-level-3', true),
        lineHeightHeading3: 1.3,
        fontSizeHeading4: getCssVarValue('font-size-level-4', true),
        lineHeightHeading4: 1.4,
        fontSizeHeading5: getCssVarValue('font-size-level-5', true),
        lineHeightHeading5: 1.5,

        colorPrimary: getCssVarValue('color-primary'),
        colorPrimaryHover: getCssVarValue('color-primary-hover'),
        colorPrimaryActive: getCssVarValue('color-primary-active'),

        colorError: getCssVarValue('color-error'),
        colorErrorHover: getCssVarValue('color-error-hover'),

        colorBgBase: getCssVarValue('color-bg-primary'),

        controlHeight: 32,
        controlHeightLG: 40,
        controlHeightSM: 24,
        borderRadius: 6,

        colorLink: getCssVarValue('color-primary'),
    },
    components: {
        Form: {
            itemMarginBottom: getCssVarValue('spacing-sm', true),
        },
        Segmented: {
            itemSelectedBg: getCssVarValue('color-primary'),
            itemSelectedColor: getCssVarValue('color-bg-primary'),
            itemHoverColor: getCssVarValue('color-text-secondary'),
            borderRadiusSM: getCssVarValue('border-radius-lg', true),
        },
        Typography: {
            titleMarginBottom: 0,
            titleMarginTop: 0,
        },
        Button: {
            defaultColor: getCssVarValue('color-primary'),
            defaultHoverColor: getCssVarValue('color-primary-hover'),
            defaultBorderColor: getCssVarValue('color-primary'),
            defaultHoverBorderColor: getCssVarValue('color-primary-hover'),
            defaultActiveBorderColor: getCssVarValue('color-primary-active'),
        },
        Table: {
            headerBg: getCssVarValue('color-fill-quaternary'),
            borderColor: getCssVarValue('color-border-secondary'),
        },
        Tag: {
            defaultBg: getCssVarValue('color-fill-quaternary'),
        },
        Modal: {
            colorBgContainer: getCssVarValue('background-color'),
            titleFontSize: getCssVarValue('font-size-level-3', true),
        },
        Dropdown: {
            paddingBlock: getCssVarValue('spacing-xs', true),
            controlPaddingHorizontal: getCssVarValue('spacing-md', true),
        },
        Steps: {
            colorText: getCssVarValue('color-primary'),
            colorSplit: getCssVarValue('color-primary'),
        },
        Menu: {
            activeBarBorderWidth: 0,
            itemSelectedBg: getCssVarValue(isFACCM ? 'color-primary-bg' : 'color-primary-bd'),
        },
        Tabs: {
            horizontalMargin: '0',
        },
        Tooltip: {
            colorBgSpotlight: getCssVarValue('color-bg-primary'),
        },
        Spin: {
            colorBgMask: getCssVarValue('color-bg-primary'),
        },
    },
});
